export enum CustomerMessageStatus {
  Normal = 'normal',
  Removed = 'removed',
  Resolved = 'resolved'
}

export enum CustomerMessageType {
  Contact = 'contact',
  Custom = 'custom',
  Invoice = 'invoice',
  Sample = 'sample',
  Reseller = 'reseller'
}

export interface CustomerMessage {
  messageID?: string;
  creationDate?: string;
  modificationDate?: string;
  type?: CustomerMessageType;
  status?: CustomerMessageStatus;
  props?: { [name: string]: any };
}

export interface CustomerMessageReplyLog {
  replyID?: string;
  messageID?: string;
  username?: string;
  creationDate?: string;
  subject?: string;
  content: string;
}
